export default "__VITE_ASSET__CItVBy1F__"